import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import store from '../store/index'

const routes = [
  // =================== 首页 ===================
  {
    path: '/',
    name: 'index',
    meta: {
      title: '首页'
    },
    component: require('@/pages/index').default
  },

  // =================== 登录 ===================
  {
    path: '/user/login',
    name: 'login',
    meta: {
      layout: 'simple'
    },
    component: require('@/pages/user/login').default
  },
  {
    path: '/user/updatePsw',
    name: 'updatePsw',
    meta: {
      title: '修改密码'
    },
    component: require('@/pages/user/updatePsw').default
  },

  // =================== 贝展 ===================
  {
    path: '/exh/create',
    name: 'exhCreate',
    meta: {
      title: '添加贝展'
    },
    component: require('@/pages/exh/create').default
  },
  {
    path: '/exh/list',
    name: 'exhList',
    meta: {
      title: '贝展列表'
    },
    component: require('@/pages/exh/list').default
  },
  {
    path: '/exh/info',
    name: 'exhInfo',
    meta: {
      title: '贝展详情'
    },
    component: require('@/pages/exh/info').default
  },
  {
    path: '/exh/update',
    name: 'exhUpdate',
    meta: {
      title: '更新贝展'
    },
    component: require('@/pages/exh/update').default
  },
  {
    path: '/exh/seller',
    name: 'exhSeller',
    meta: {
      title: '参展贝商'
    },
    component: require('@/pages/exh/seller/list').default
  },
  // =================== 贝展日程 ===================
  {
    path: '/schedule/list',
    name: 'scheduleList',
    meta: {
      title: '贝展日程'
    },
    component: require('@/pages/schedule/list').default
  },

  // =================== 贝展公告 ===================
  {
    path: '/notice/list',
    name: 'noticeList',
    meta: {
      title: '贝展公告'
    },
    component: require('@/pages/notice/list').default
  },

  // =================== 活动 ===================
  {
    path: '/activity/create',
    name: 'activityCreate',
    meta: {
      title: '添加活动'
    },
    component: require('@/pages/activity/create').default
  },
  {
    path: '/activity/list',
    name: 'activityList',
    meta: {
      title: '活动列表'
    },
    component: require('@/pages/activity/list').default
  },
  {
    path: '/activity/info',
    name: 'activityInfo',
    meta: {
      title: '活动详情'
    },
    component: require('@/pages/activity/info').default
  },
  {
    path: '/activity/update',
    name: 'activityUpdate',
    meta: {
      title: '更新活动'
    },
    component: require('@/pages/activity/update').default
  },
  {
    path: '/activity/section/list',
    name: 'activitySectionList',
    meta: {
      title: '活动环节列表'
    },
    component: require('@/pages/activity/section/list').default
  },
  {
    path: '/activity/form/list',
    name: 'activityformList',
    meta: {
      title: '报名表单管理'
    },
    component: require('@/pages/activity/form/list').default
  },
  {
    path: '/activity/yaoqing/list',
    name: 'activityYaoqingList',
    meta: {
      title: '邀请管理'
    },
    component: require('@/pages/activity/yaoqing/list').default
  },
  {
    path: '/activity/join/list',
    name: 'activityJoinList',
    meta: {
      title: '报名列表'
    },
    component: require('@/pages/activity/join/list').default
  },
  {
    path: '/activity/join/detail',
    name: 'activityJoinDetail',
    meta: {
      title: '报名详情'
    },
    component: require('@/pages/activity/join/detail').default
  },









  // =================== 用户管理 ===================
  {
    path: '/user/create',
    name: 'userCreate',
    meta: {
      title: '添加用户'
    },
    component: require('@/pages/user/create').default
  },
  {
    path: '/user/list',
    name: 'userList',
    meta: {
      title: '用户列表'
    },
    component: require('@/pages/user/list').default
  },
  {
    path: '/user/group',
    name: 'userGroup',
    meta: {
      title: '用户分组'
    },
    component: require('@/pages/user/group').default
  },

  // =================== 资料库 ===================
  {
    path: '/article/list',
    name: 'article',
    meta: {
      title: '文章列表'
    },
    component: require('@/pages/article/list').default
  },
  {
    path: '/article/create',
    name: 'addarticle',
    meta: {
      title: '添加文章'
    },
    component: require('@/pages/article/create').default
  },
  {
    path: '/article/cate',
    name: 'articleCate',
    meta: {
      title: '资料分类'
    },
    component: require('@/pages/article/cate').default
  },
  {
    path: '/article/doc',
    name: 'publicDoc',
    meta: {
      title: '共享文档'
    },
    component: require('@/pages/article/doc').default
  },
  {
    path: '/article/view',
    name: 'articleView',
    meta: {
      title: '查看文章'
    },
    component: require('@/pages/article/view').default
  },
  {
    path: '/article/edit',
    name: 'articleEdit',
    meta: {
      title: '编辑文章'
    },
    component: require('@/pages/article/edit').default
  },

  // 贝商
  {
    path: '/seller/list',
    name: 'sellerList',
    meta: {
      title: '贝商列表'
    },
    component: require('@/pages/seller/list').default
  },
  {
    path: '/seller/create',
    name: 'sellerCreate',
    meta: {
      title: '添加贝商'
    },
    component: require('@/pages/seller/create').default
  },
  {
    path: '/seller/info',
    name: 'sellerInfo',
    meta: {
      title: '贝商详情'
    },
    component: require('@/pages/seller/info').default
  },
  {
    path: '/seller/update',
    name: 'sellerUpdate',
    meta: {
      title: '更新贝商信息'
    },
    component: require('@/pages/seller/update').default
  },

  // =================== 拍卖 ===================
  {
    path: '/auction/create',
    name: 'auctionCreate',
    meta: {
      title: '添加拍卖'
    },
    component: require('@/pages/auction/create').default
  },
  {
    path: '/auction/list',
    name: 'auctionList',
    meta: {
      title: '拍卖列表'
    },
    component: require('@/pages/auction/list').default
  },
  {
    path: '/auction/info',
    name: 'auctionInfo',
    meta: {
      title: '拍卖详情'
    },
    component: require('@/pages/auction/info').default
  },
  {
    path: '/auction/update',
    name: 'auctionUpdate',
    meta: {
      title: '更新拍卖'
    },
    component: require('@/pages/auction/update').default
  },
  // 拍卖商品
  {
    path: '/auction/goods/create',
    name: 'auctionGoodsCreate',
    meta: {
      title: '添加拍品'
    },
    component: require('@/pages/auction/goods/create').default
  },
  {
    path: '/auction/goods/import',
    name: 'auctionGoodsImport',
    meta: {
      title: '批量导入'
    },
    component: require('@/pages/auction/goods/import').default
  },
  {
    path: '/auction/goods/list',
    name: 'auctionGoodsList',
    meta: {
      title: '拍品列表'
    },
    component: require('@/pages/auction/goods/list').default
  },
  {
    path: '/auction/goods/qr',
    name: 'auctionGoodsQr',
    meta: {
      title: '拍品二维码',
      layout: 'simple'
    },
    component: require('@/pages/auction/goods/qr').default
  },
  {
    path: '/auction/goods/info',
    name: 'auctionGoodsInfo',
    meta: {
      title: '拍品详情'
    },
    component: require('@/pages/auction/goods/info').default
  },
  {
    path: '/auction/goods/update',
    name: 'auctionGoodsUpdate',
    meta: {
      title: '更新拍品'
    },
    component: require('@/pages/auction/goods/update').default
  },
  {
    path: '/auction/goods/bidList',
    name: 'auctionGoodsBidList',
    meta: {
      title: '出价记录'
    },
    component: require('@/pages/auction/goods/bidList').default
  },

  // 订单列表
  {
    path: '/auction/order/list',
    name: 'auctionOrderList',
    meta: {
      title: '订单列表'
    },
    component: require('@/pages/auction/order/list').default
  },
  // 订单商品
  {
    path: '/auction/order/goodsList',
    name: 'auctionOrderGoodsList',
    meta: {
      title: '订单商品列表'
    },
    component: require('@/pages/auction/order/goodsList').default
  },

  // 签到列表
  {
    path: '/checkin/list',
    name: 'checkinList',
    meta: {
      title: '签到记录'
    },
    component: require('@/pages/checkin/list').default
  },

  // =================== 团拍 ===================
  {
    path: '/tuanpai/create',
    name: 'tuanpaiCreate',
    meta: {
      title: '添加团拍'
    },
    component: require('@/pages/tuanpai/create').default
  },
  {
    path: '/tuanpai/list',
    name: 'tuanpaiList',
    meta: {
      title: '团拍列表'
    },
    component: require('@/pages/tuanpai/list').default
  },
  {
    path: '/tuanpai/info',
    name: 'tuanpaiInfo',
    meta: {
      title: '团拍详情'
    },
    component: require('@/pages/tuanpai/info').default
  },
  {
    path: '/tuanpai/update',
    name: 'tuanpaiUpdate',
    meta: {
      title: '更新团拍'
    },
    component: require('@/pages/tuanpai/update').default
  },
  // 拍卖商品
  {
    path: '/tuanpai/goods/create',
    name: 'tuanpaiGoodsCreate',
    meta: {
      title: '添加拍品'
    },
    component: require('@/pages/tuanpai/goods/create').default
  },
  {
    path: '/tuanpai/goods/list',
    name: 'tuanpaiGoodsList',
    meta: {
      title: '拍品列表'
    },
    component: require('@/pages/tuanpai/goods/list').default
  },
  {
    path: '/tuanpai/goods/qr',
    name: 'tuanpaiGoodsQr',
    meta: {
      title: '拍品二维码',
      layout: 'simple'
    },
    component: require('@/pages/tuanpai/goods/qr').default
  },
  {
    path: '/tuanpai/goods/info',
    name: 'tuanpaiGoodsInfo',
    meta: {
      title: '拍品详情'
    },
    component: require('@/pages/tuanpai/goods/info').default
  },
  {
    path: '/tuanpai/goods/update',
    name: 'tuanpaiGoodsUpdate',
    meta: {
      title: '更新拍品'
    },
    component: require('@/pages/tuanpai/goods/update').default
  },
  {
    path: '/tuanpai/goods/bidList',
    name: 'tuanpaiGoodsBidList',
    meta: {
      title: '出价记录'
    },
    component: require('@/pages/tuanpai/goods/bidList').default
  },
  // 赢家列表
  {
    path: '/tuanpai/winner/list',
    name: 'tuanpaiWinnerList',
    meta: {
      title: '赢家列表'
    },
    component: require('@/pages/tuanpai/winner/list').default
  },


  // 订单列表
  {
    path: '/tuanpai/order/list',
    name: 'tuanpaiOrderList',
    meta: {
      title: '订单列表'
    },
    component: require('@/pages/tuanpai/order/list').default
  },
  // 订单商品
  {
    path: '/tuanpai/order/info',
    name: 'tuanpaiOrderInfo',
    meta: {
      title: '订单商品列表'
    },
    component: require('@/pages/tuanpai/order/info').default
  },

  {
    path: '/tuanpai/tongji',
    name: 'tuanpaiTongji',
    meta: {
      title: '团拍统计'
    },
    component: require('@/pages/tuanpai/tongji').default
  },

  // =================== 贝壳城 ===================
  {
    path: '/shellCity/applyList',
    name: 'shellCityApplyList',
    meta: {
      title: '申请列表'
    },
    component: require('@/pages/shellCity/applyList').default
  },
  {
    path: '/shellCity/edit',
    name: 'shellCityApplyEdit',
    meta: {
      title: '编辑城员'
    },
    component: require('@/pages/shellCity/edit').default
  },
  {
    path: '/shellCity/detail',
    name: 'shellCityApplyDetail',
    meta: {
      title: '城员详情'
    },
    component: require('@/pages/shellCity/detail').default
  },
  {
    path: '/shellCity/huodong/list',
    name: 'shellCityHuodongList',
    meta: {
      title: '活动列表'
    },
    component: require('@/pages/shellCity/huodong/list').default
  },
  {
    path: '/shellCity/huodong/joinList',
    name: 'shellCityHuodongJoinList',
    meta: {
      title: '参加记录'
    },
    component: require('@/pages/shellCity/huodong/joinList').default
  },
  {
    path: '/shellCity/jianjie',
    name: 'shellCityJianjie',
    meta: {
      title: '社区简介'
    },
    component: require('@/pages/shellCity/jianjie').default
  },
  {
    path: '/shellCity/jiaofeiRecord',
    name: 'shellCityJiaofeiRecord',
    meta: {
      title: '缴费记录'
    },
    component: require('@/pages/shellCity/jiaofeiRecord').default
  },
  // =================== 门票 ===================
  {
    path: '/exhMenpiao/list',
    name: 'exhMenpiaoList',
    meta: {
      title: '门票'
    },
    component: require('@/pages/exhMenpiao/list').default
  },
  {
    path: '/exhMenpiao/menpiaoTongji',
    name: 'menpiaoTongji',
    meta: {
      title: '门票统计'
    },
    component: require('@/pages/exhMenpiao/menpiaoTongji').default
  },
  {
    path: '/exhMenpiao/tongji',
    name: 'exhMenpiaoTongji',
    meta: {
      title: '销售统计'
    },
    component: require('@/pages/exhMenpiao/tongji').default
  },

  // =================== 尺寸记录 ===================
  {
    path: '/chicun/list',
    name: 'chicunList',
    meta: {
      title: '尺寸记录'
    },
    component: require('@/pages/chicun/list').default
  },
  {
    path: '/chicun/userList',
    name: 'chicunUserList',
    meta: {
      title: '用户列表'
    },
    component: require('@/pages/chicun/userList').default
  },
  {
    path: '/chicun/logDetail',
    name: 'chicunlogDetail',
    meta: {
      title: '尺寸详情'
    },
    component: require('@/pages/chicun/logDetail').default
  },
  {
    path: '/chicun/logEdit',
    name: 'chicunlogEdit',
    meta: {
      title: '编辑尺寸'
    },
    component: require('@/pages/chicun/logEdit').default
  }
  
]

const router = new VueRouter({
  routes
})


router.beforeEach((to, from, next) => {
  const navs = store.state.navs;
  let selectedKeys = []; //当前选中菜单
  let openKeys = []; //当前展开菜单
  const breadcrumbs = []; //面包屑

  const now_path = to.path;
  let nowNav; //当前正在运算的nav

  for (let nav of navs) {
    if (nav.path == now_path || nav.route == now_path) {
      nowNav = nav;
      break
    }
  }

  if (!nowNav) return next()

  const getFather = (id) => {
    for (let nav of navs) {
      if (nav.id == id) return nav
    }
  }

  // 根据father层层查找
  const hello = (nowNav) => {
    breadcrumbs.unshift(nowNav.title);
    if (nowNav.class == 2 && nowNav.father) selectedKeys.unshift(nowNav.id);
    if (nowNav.class == 1 && !nowNav.father) openKeys.unshift(nowNav.id);

    if (nowNav.father !== 0) {
      const father = getFather(nowNav.father);
      hello(father)
    }
  }

  if (nowNav.class == 1) {
    selectedKeys.unshift(nowNav.id);
    breadcrumbs.unshift(nowNav.title);
  }
  else {
    hello(nowNav)
  }

  store.commit('setActiveMenu', {
    selectedKeys,
    openKeys,
    breadcrumbs
  })

  next()
})

// 避免跳转到当前网址的报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default router
